<template>
    <div>
        <headerNav title="红包领取记录" />
       
        <!-- <img style="width: 100%" src="../../assets/images/fh001.jpg" /> -->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="vlist">
             <van-list
                v-model="navitem.loaded"
                :finished="navitem.loadingType == 'nomore' ? true : false"
                @load="loadData"
            >
                <div class="vcard" v-for="(item,index) in navitem.list" :key="index">
                    <div class="fitem">
                        系统单号：{{item.giveTid}}
                        <span class="fright" >
                            <van-tag type="success" v-if="item.isGive">已发放</van-tag>
                            <van-tag type="danger" v-if="!item.isGive">未发放</van-tag>
                        </span>
                    </div>
                    <div class="clearboth"></div>
                    <div class="fitem">
                        发放金额：{{item.realMoney}}
                        <span class="fright" v-if="item.giveTime">
                            {{item.giveTime}}
                        </span>
                    </div>
                </div>
            </van-list>
        </div>
        </van-pull-refresh>

       <div class="ffooter">
           <div>
               如红包未发放成功，请联系上家或客服处理
           </div>
       </div>
    </div>
</template>
<script>
export default {
    data()
    {
        return{
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: " sorter desc,id desc",
                    maxResultCount: 10,
                    skipCount: 0,
                },
                list: [],
            },
            loading: false,
            finished: false,
            refreshing: false,
            nshow:false,
            parentinfo:undefined,
            fshow:false
        }
    },
    created(){
        
    },
    methods:
    {
        querydefault() {
            // let id=localStorage.getItem('changeaddress') || 0;
            // localStorage.setItem('changeaddress',''); 
            this.ajax
                .post("/api/services/app/PhoneUser/QueryDefaultAddress?id=0")
                .then((x) => {
                    this.defaultaddress = x.result;
                    
                });
        },
        onRefresh() {
         this.loadData("refresh");
        },
        loadData(source) {
           
            let navItem = this.navitem;
            // let state = navItem.state;

            if (source === "tabChange" && navItem.loaded === true) {
                //tab切换只有第一次需要加载数据
                return;
            }
            if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
                //防止重复加载
                if (source != "refresh") {
                return;
                }
            }
            if (source === "refresh") {
                this.navitem.list = [];
                this.navitem.getparams.skipCount = 0;
            }
            this.navitem.loadingType = "loading";
            var params = navItem.getparams;
            
            //加载数据
            this.ajax
                .post("/api/services/app/PhoneRedPaper/QueryRedPaperPersonList", params)
                .then((x) => {
                this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.navitem.list = this.navitem.list.concat(x.result.items);
                //console.log(this.navList);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.navitem.loadingType =
                    totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
                })
                .finally(() => {
                this.$set(this.navitem, "loaded", false);
                this.refreshing = false;
                });
            },
    }
}
</script>
<style lang="scss" scoped>
    .vlist{
        padding: 10px 10px;
        font-size: 14px;
        margin-bottom: 45px;
    }
 .vcard{
     background-color: white;
     padding: 10px 10px;
     border-radius: 5px;
     margin-bottom: 10px;
 }
 .fitem{
     margin-bottom: 5px;
 }
 .clearboth{
     clear: both;
 }
 .fright{
     float: right;
     font-size: 12px;
     vertical-align: bottom;
     margin-top: 4px;
 }
 .ffooter{
     position: fixed;
     bottom: 0px;
     left:0;
     right: 0;
     background-color: white;
     padding: 10px;
     font-size: 16px;
     color:red;
 }
</style>